import { useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import '../styles/Gallery.scss';

function Gallery(props: { title: string }) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = props.title;
  });
  return (
    <div className="gallery-page">
      <div className="title-wrapper">
        <h1>
          Imagine your future
          <span className="semi-transparent">with Alnair</span>
        </h1>
      </div>
      <div className="list-wrapper">
        <ul>
          <li>
            <NavLink
              to="/gallery/tech-unity"
              style={({ isActive }) => ({
                opacity: isActive || pathname === '/gallery' ? 1 : 0.3,
              })}
            >
              Tech Unity: Clusters Forum
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/aws"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              AWS re:Invent 2025
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/rnd_day"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              R&D Day
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/siemens-lab"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              Siemens Lab with KPMG
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/dou-day-picnic"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              DOU Day Picnic
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/general"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              General
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/winter-emea-sko"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              Winter EMEA SKO
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/austin-hq"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              Austin HQ
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/warsaw-office-opening"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              Warsaw Office Opening
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/gartner-it-symposium"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              Gartner IT Symposium
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery/it-arena"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              IT Arena
            </NavLink>
          </li>
          {/* <li>
          <NavLink
            to="/gallery/soft-serve-anniversary"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.3,
            })}
          >
            SoftServe Anniversary
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/gallery/it-manager"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.3,
            })}
          >
            IT Manager
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/gallery/ai-data-expo"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.3,
            })}
          >
            AI & Data Expo
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/gallery/code-camp-timisoara"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.3,
            })}
          >
            CodeCamp Timisoara
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/gallery/web-summit"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.3,
            })}
          >
            WEB SUMMIT
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/gallery/money-2020"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.3,
            })}
          >
            MONEY 20/20
          </NavLink>
        </li> */}
        {/* <li>
          <NavLink
            to="/gallery/TEST"
            style={({ isActive }) => ({
              opacity: isActive ? 1 : 0.3,
            })}
          >
            TEST
          </NavLink>
        </li> */}
          <li>
            <NavLink
              to="/gallery/next-event"
              style={({ isActive }) => ({
                opacity: isActive ? 1 : 0.3,
              })}
            >
              NEXT EVENT
            </NavLink>
          </li>
        </ul>
      </div>
      <Outlet />
    </div>
  );
}

export default Gallery;
